import { StepConfig } from "projects/mydocma/import-export/src/lib/stepper/step/step.config";
import { StepperConfig } from "projects/mydocma/import-export/src/lib/stepper/stepper.config";



export const step1: StepConfig =     {
  name: 'step1',
  label: 'step1',
  icon: {
    number: 'toggle_off',
    edit: 'toggle_off',
    done: 'toggle_off'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step2: StepConfig = {
  name: 'step2',
  label: 'step2',
  icon: {
    number: 'remove_red_eye',
    edit: 'remove_red_eye',
    done: 'remove_red_eye'
  },
  optional: false,
  editable: true,
  enabled: true
};

export const step3: StepConfig = {
  name: 'step3',
  label: 'step3',
  icon: {
    number: 'done',
    edit: 'done',
    done: 'done'
  },
  optional: false,
  editable: true,
  enabled: true
};




export const navStepperConfig: StepperConfig = {
  steps: [
    step1,
    step2,
    step3,
  ]
};
